import { useEffect, useRef, useState } from "react";
import { NavLink, Outlet, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ArrowLeft } from "lucide-react";
import { getApplicantList, getJobById } from "@endpoints/job.service";
import { setJobDetail } from "@store/actions/job.action";
import JobDetailsRightPanel from "./components/JobDetailsRightPanel";

const tabs = [
  { name: "Job Details", path: "job-details" },
  { name: "Application Management", path: "applicants" },
];

const JobDetailPageLayout = () => {
  const navigate = useNavigate();
  const { jobId } = useParams();
  const dispatch = useDispatch();
  const hasFetched = useRef(false);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true;
      fetchJobDetails();
    }
  }, []);

  const fetchJobDetails = async () => {
    try {
      const jobResponse = await getJobById({ jobId });
      const { data: jobData, success: jobSuccess } = jobResponse;
      if (jobSuccess) {
        const applicantResponse = await getApplicantList(jobId);
        const { data: applicantData, success: applicantSuccess } =
          applicantResponse;
        if (applicantSuccess) {
          dispatch(setJobDetail({ ...jobData, applicantData }));
        } else {
          dispatch(setJobDetail({ ...jobData, applicantData }));
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-1 min-h-0 gap-3">
      {/* Left section */}
      <div className="flex flex-col flex-1 min-h-0 gap-3">
        {/* Header */}
        <div className="flex items-center rounded-md bg-white border overflow-hidden">
          <button
            onClick={() => navigate("/job")}
            className="group flex items-center gap-2 hover:bg-slate-100 h-11 pl-3 pr-10"
          >
            <span className="rounded-full p-1 border text-content group-hover:bg-slate-600 group-hover:text-white">
              <ArrowLeft size={13} />
            </span>
            <span className="font-semibold text-xs">Jobs</span>
          </button>
          {/* Tab section */}
          <div className="flex items-center flex-1">
            {tabs?.map((tab) => {
              return (
                <NavLink
                  key={tab?.path}
                  to={tab?.path}
                  className={({ isActive }) =>
                    `flex items-center h-11 px-7 ${
                      isActive
                        ? "bg-slate-600 text-white"
                        : "text-slate-600 hover:bg-slate-100"
                    }`
                  }
                >
                  <span className="font-medium text-xs">{tab?.name}</span>
                </NavLink>
              );
            })}
          </div>
        </div>
        {/* Main Body */}
        <div className="flex flex-col min-h-0 flex-1">
          <Outlet />
        </div>
      </div>

      {/* Right section */}
      <JobDetailsRightPanel />
    </div>
  );
};

export default JobDetailPageLayout;
